import React from "react";
import { getMorningAndEveningCelebrations } from "../calendar/ordinariate-calendar";
import { useDataDependency } from "../utils/RemoteDataProvider";

export const SpecialExport: React.FC<{}> = () => {
    const year = new Date().getFullYear();

    const regionLabels =
        localStorage.getItem("region-switches")?.split(";;;") ?? [];

    const days = getMorningAndEveningCelebrations(
        year,
        false,
        false,
        false,
        regionLabels
    );

    const loadableTextList = useDataDependency<string[]>({
        type: "special export",
    });

    console.log(loadableTextList);

    if (loadableTextList.state === "loaded") {
        return <div>Done</div>;
    }

    return <div>Loading...</div>;
};
